export const appHead = {"meta":[{"charset":"utf-8"},{"name":"description","content":"Стоматологический центр в Москве АО Стом. Низкие цены. Бесплатная парковка. Профессиональные врачи. Современное оборудование. Безопасность лечения"},{"name":"keywords","content":"стоматологический центр ао стом в москве"},{"property":"og:title","content":"AO-СТОМ"},{"property":"og:description","content":"Стоматологический центр в Москве АО Стом. Низкие цены. Бесплатная парковка. Профессиональные врачи. Современное оборудование. Безопасность лечения"},{"property":"og:image","content":"/android-chrome-192x192.png"},{"hid":"viewport","name":"viewport","content":"width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0"},{"hid":"format-detection","name":"format-detection","content":"telephone=no"},{"hid":"HandheldFriendly","name":"HandheldFriendly","content":"true"}],"link":[],"style":[],"script":[],"noscript":[],"title":"AO-СТОМ","htmlAttrs":[{"lang":"ru"}]}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = false

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"deep":true}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false